import { render, staticRenderFns } from "./GymSpaceRouteSort.vue?vue&type=template&id=628ade14"
import script from "./GymSpaceRouteSort.vue?vue&type=script&lang=js"
export * from "./GymSpaceRouteSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports